import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import React, { Component } from 'react';
import isMatch from 'lodash/isMatch';
import once from 'lodash/once';
import PropTypes from 'prop-types';
import window from 'window-or-global';
import { AnalyticsEvent, AnalyticsListener } from '@atlaskit/analytics-next';
import { MessageDeliveryStatus, shouldBeChoreographed } from '@atlassian/ipm-choreographer';
import { startMessage, stopMessage } from '../../services/engage-targeting';
import { sendOperationalEvent, sendScreenEvent, sendUIEvent } from '../../services/gasv3';
import { getBrowserInfo } from '../../utils/browser';
import createCustomEvent from '../../utils/createCustomEvent';
import { isMessagingEnabled } from '../../utils/messaging';
import { clearCurrent, setCurrent } from '../engagement-actions';
import Queue from '../queue';
var MAX_EVENT_QUEUE_SIZE = 100;
var EK_LOADED_EVENT = 'engagement.inproduct.loaded';
export var ANALYTIC_EVENT_DOM_EVENT_NAME = 'ep.analyticEvent';
function collapseEventToPayload(event) {
  var payload = _objectSpread(_objectSpread({}, event.payload), {}, {
    context: {}
  });
  Object.assign.apply(Object, [payload.context].concat(_toConsumableArray(event.context)));
  return payload;
}
function findMatchingTrigger(messageMapping, payload) {
  return Array.from(messageMapping.keys()).find(function (trigger) {
    return isMatch(payload, trigger);
  });
}
function fireExposureEvent(attributes, clientOrPromise) {
  var analyticsEvent = new AnalyticsEvent({
    payload: {
      action: 'exposed',
      actionSubject: 'feature',
      actionSubjectId: attributes.flagKey,
      source: 'engagement-platform',
      attributes: attributes
    }
  });
  Promise.resolve(clientOrPromise).then(function (client) {
    client.sendTrackEvent(analyticsEvent.payload);
  });
}
function getExposureAttributes(messageId, cohort, additionalProps) {
  return _objectSpread({
    reason: 'RULE_MATCH',
    ruleId: 'engagement.inproduct',
    flagKey: "engagement.inproduct.".concat(messageId),
    value: cohort
  }, additionalProps);
}
function getBaseAttributes(messageId, variationId, componentId, locale) {
  return {
    messageId: messageId,
    variationId: variationId,
    componentIndex: componentId,
    locale: locale
  };
}

// TODO refactor this to be inside EngagementProvider
// Instead of calling out to fireAnalyticsEvent we can call this.fireEvent
export function triggerShown(_x, _x2, _x3, _x4, _x5, _x6) {
  return _triggerShown.apply(this, arguments);
}
function _triggerShown() {
  _triggerShown = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(eventMapping, config, store, clientOrPromise, coordinationOptions, componentConfig) {
    var locale, message, component, success;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          locale = config.locale;
          message = eventMapping.message, component = eventMapping.component;
          if (!message.holdout) {
            _context2.next = 9;
            break;
          }
          _context2.next = 5;
          return startMessage({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: message.messageId,
            variationId: message.variationId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
          }, coordinationOptions);
        case 5:
          _context2.next = 7;
          return stopMessage({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: message.messageId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
          }, coordinationOptions);
        case 7:
          fireExposureEvent(getExposureAttributes(message.messageId, 'holdout', {
            locale: locale
          }), clientOrPromise);
          return _context2.abrupt("return");
        case 9:
          if (!(component.componentId === 0)) {
            _context2.next = 17;
            break;
          }
          _context2.next = 12;
          return startMessage({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: message.messageId,
            variationId: message.variationId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
          }, coordinationOptions);
        case 12:
          success = _context2.sent;
          if (coordinationOptions !== null && coordinationOptions !== void 0 && coordinationOptions.enableChoreographer && componentConfig !== null && componentConfig !== void 0 && componentConfig.onMessageDisposition) {
            componentConfig.onMessageDisposition(success ? MessageDeliveryStatus.STARTED : MessageDeliveryStatus.BLOCKED);
          }
          if (success) {
            fireExposureEvent(getExposureAttributes(message.messageId, message.variationId, {
              locale: locale
            }), clientOrPromise);
            store.dispatch(setCurrent(eventMapping));
          }
          _context2.next = 19;
          break;
        case 17:
          fireExposureEvent(getExposureAttributes(message.messageId, message.variationId, {
            locale: locale
          }), clientOrPromise);
          store.dispatch(setCurrent(eventMapping));
        case 19:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _triggerShown.apply(this, arguments);
}
// eslint-disable-next-line @repo/internal/react/no-class-components
export var EngagementProvider = /*#__PURE__*/function (_Component) {
  function EngagementProvider(props) {
    var _this;
    _classCallCheck(this, EngagementProvider);
    _this = _callSuper(this, EngagementProvider, [props]);
    _defineProperty(_this, "onStoreChange", function (state) {
      var createAnalyticsEvent = _this.props.createAnalyticsEvent;
      var config = _this.getConfig();
      var locale = config.locale;
      if (state.initialized) {
        if (!EngagementProvider.hasInitializedAtLeastOneEngagementProvider) {
          _this.sendOperationalEventWithClient({
            action: 'loaded',
            actionSubject: 'messages',
            actionSubjectId: undefined,
            source: 'engagekit',
            attributes: {
              locale: locale
            }
          });
          var browserInfo = getBrowserInfo();
          _this.onEvent(createAnalyticsEvent({
            event: EK_LOADED_EVENT,
            properties: {
              browser: browserInfo.name,
              browserVersion: browserInfo.version
            }
          }));
          EngagementProvider.hasInitializedAtLeastOneEngagementProvider = true;
        }
        _this.analyticsEventQueue.flush(_this.onEvent);
        if (_this.unsubscribeFromStore) {
          _this.unsubscribeFromStore();
        }
      }
    });
    _defineProperty(_this, "onEvent", function (event) {
      var _eventMapping$compone;
      var state = _this.getState();
      if (!state.initialized) {
        var success = _this.analyticsEventQueue.enqueue(event);
        if (!success) {
          _this.fireQueueOverflowEvent();
        }
        return;
      }
      var _this$props = _this.props,
        eventTarget = _this$props.eventTarget,
        store = _this$props.store,
        analyticsClientInstance = _this$props.analyticsClientInstance;
      var config = _this.getConfig();
      var current = state.current,
        messageMapping = state.messageMapping;
      var payload = collapseEventToPayload(event);
      eventTarget.dispatchEvent(createCustomEvent({
        eventName: ANALYTIC_EVENT_DOM_EVENT_NAME,
        canBubble: false,
        cancellable: false,
        detail: payload
      }));
      if (!isMessagingEnabled()) {
        return;
      }

      // existing message found
      if (current) {
        return;
      }
      var trigger = findMatchingTrigger(messageMapping, payload);

      // No messages found for trigger
      if (!trigger) {
        return;
      }
      var eventMapping = messageMapping.get(trigger);
      var componentConfig;
      if ((_eventMapping$compone = eventMapping.component) !== null && _eventMapping$compone !== void 0 && _eventMapping$compone.componentType) {
        var componentConfigId = _this.getConfigId(eventMapping.component.componentType, eventMapping.component.target);
        componentConfig = EngagementProvider.componentConfig.get(componentConfigId);
      }
      var coordinationOptions = _this.getComponentCoordinationOptions(componentConfig);
      triggerShown(eventMapping, config, store, analyticsClientInstance, coordinationOptions, componentConfig);
    });
    _defineProperty(_this, "onEngagementEvent", function (event) {
      var _event$payload = event.payload,
        action = _event$payload.action,
        clickType = _event$payload.clickType,
        ekMessageId = _event$payload.ekMessageId,
        ekVariationId = _event$payload.ekVariationId,
        ekComponentId = _event$payload.ekComponentId,
        ekComponentType = _event$payload.ekComponentType,
        ekIsLast = _event$payload.ekIsLast;
      var config = _this.getConfig();
      var locale = config.locale;
      var attributes = getBaseAttributes(ekMessageId, ekVariationId, ekComponentId, locale);
      if (action === 'click') {
        _this.handleClickEvent(ekMessageId, ekVariationId, ekComponentId);
        attributes.buttonType = clickType;
        _this.sendUIEventWithClient({
          action: 'clicked',
          actionSubject: 'button',
          actionSubjectId: "".concat(clickType, "Button"),
          source: "engagement_".concat(ekComponentType),
          attributes: attributes
        });
      } else {
        if (action === 'shown') {
          attributes.componentType = ekComponentType;
          _this.sendScreenEventWithClient({
            name: "engagement_".concat(ekComponentType),
            attributes: attributes
          });
        }
        if (action === 'hidden') {
          attributes.isLast = ekIsLast;
          _this.sendUIEventWithClient({
            action: 'hid',
            actionSubject: 'component',
            actionSubjectId: undefined,
            source: "engagement_".concat(ekComponentType),
            attributes: attributes
          });
        }
      }
      _this.onEvent(event);
    });
    _defineProperty(_this, "subscribeEngagementState", function (callback) {
      var store = _this.props.store;
      callback(store.getState());
      return store.subscribe(function () {
        callback(store.getState());
      });
    });
    _defineProperty(_this, "getComponentCoordinationOptions", function (componentConfig) {
      var _this$props$coordinat;
      // Default enableChoreographer to the EngagementProvider's coordinationOptions
      var enableChoreographer = Boolean((_this$props$coordinat = _this.props.coordinationOptions) === null || _this$props$coordinat === void 0 ? void 0 : _this$props$coordinat.enableChoreographer);
      return _objectSpread(_objectSpread({}, _this.props.coordinationOptions), {}, {
        enableChoreographer: componentConfig !== null && componentConfig !== void 0 && componentConfig.messageType ?
        // Use the component's individual choreographer configuration, if defined,
        // regardless of the EngagementProvider's coordinationOptions
        shouldBeChoreographed(componentConfig, {
          enableChoreographer: true
        }) : enableChoreographer
      });
    });
    _defineProperty(_this, "getConfigId", function (componentType, engagementId) {
      return engagementId ? "".concat(componentType, "-").concat(engagementId) : componentType;
    });
    _defineProperty(_this, "setComponentConfig", function (componentType, config, engagementId) {
      var configId = _this.getConfigId(componentType, engagementId);
      EngagementProvider.componentConfig.set(configId, config);
      return function () {
        return _this.removeComponentConfig(configId);
      };
    });
    _defineProperty(_this, "removeComponentConfig", function (configId) {
      if (EngagementProvider.componentConfig.has(configId)) {
        EngagementProvider.componentConfig.delete(configId);
      }
    });
    var _analyticsClientInstance = _this.props.analyticsClientInstance;
    _this.sendUIEventWithClient = sendUIEvent.bind(null, _analyticsClientInstance);
    _this.sendScreenEventWithClient = sendScreenEvent.bind(null, _analyticsClientInstance);
    _this.sendOperationalEventWithClient = sendOperationalEvent.bind(null, _analyticsClientInstance);
    _this.analyticsEventQueue = new Queue(MAX_EVENT_QUEUE_SIZE);
    _this.unsubscribeFromStore = _this.subscribeEngagementState(_this.onStoreChange);
    _this.fireQueueOverflowEvent = once(
    // TODO: create metric for this with Metal
    function () {});
    return _this;
  }
  _inherits(EngagementProvider, _Component);
  return _createClass(EngagementProvider, [{
    key: "getConfig",
    value: function getConfig() {
      var _this$getState = this.getState(),
        config = _this$getState.config;
      return config;
    }
  }, {
    key: "getChildContext",
    value: function getChildContext() {
      return {
        subscribeEngagementState: this.subscribeEngagementState,
        setComponentConfig: this.setComponentConfig
      };
    }
  }, {
    key: "getState",
    value: function getState() {
      return this.props.store.getState();
    }
  }, {
    key: "getActiveMessage",
    value: function getActiveMessage() {
      return this.getState().current;
    }
  }, {
    key: "completeMessage",
    value: function () {
      var _completeMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(messageId, componentConfig) {
        var config, coordinationOptions, disposition;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              config = this.getConfig();
              coordinationOptions = this.getComponentCoordinationOptions(componentConfig);
              _context.next = 4;
              return stopMessage({
                cloudId: config.cloudId,
                stargateUrl: config.stargateUrl,
                messageId: messageId,
                orgId: config.orgId,
                workspaceId: config.workspaceId
              }, coordinationOptions);
            case 4:
              disposition = _context.sent;
              if (coordinationOptions.enableChoreographer && componentConfig !== null && componentConfig !== void 0 && componentConfig.onMessageDisposition) {
                componentConfig.onMessageDisposition(disposition ? MessageDeliveryStatus.STOPPED : MessageDeliveryStatus.CANCELED);
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function completeMessage(_x7, _x8) {
        return _completeMessage.apply(this, arguments);
      }
      return completeMessage;
    }()
  }, {
    key: "handleClickEvent",
    value: function handleClickEvent(messageId, variationId, componentId) {
      var activeMessage = this.getActiveMessage();

      // It is important to check that the event we're handling matches the
      // current active message because it is possible for an event to come
      // through for a past message. We don't want to mess up the current
      // message by calling clearCurrent just because the old message is done.
      if (!activeMessage || activeMessage.messageId !== messageId || activeMessage.variationId !== variationId || activeMessage.componentId !== componentId) {
        return;
      }
      var componentConfig;
      if (activeMessage.componentType) {
        var componentConfigId = this.getConfigId(activeMessage.componentType, activeMessage.target);
        componentConfig = EngagementProvider.componentConfig.get(componentConfigId);
      }
      if (activeMessage.isLast) {
        this.completeMessage(messageId, componentConfig);
      }
      this.props.store.dispatch(clearCurrent());
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unsubscribeFromStore && this.unsubscribeFromStore();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(AnalyticsListener, {
        channel: "*",
        onEvent: this.onEvent
      }, /*#__PURE__*/React.createElement(AnalyticsListener, {
        channel: "engagement",
        onEvent: this.onEngagementEvent
      }, this.props.children));
    }
  }]);
}(Component);
_defineProperty(EngagementProvider, "componentConfig", new Map());
_defineProperty(EngagementProvider, "childContextTypes", {
  subscribeEngagementState: PropTypes.func,
  setComponentConfig: PropTypes.func
});
_defineProperty(EngagementProvider, "defaultProps", {
  eventTarget: window
});
/*
 * We use this flag for ensuring that we only fire the engagement.inproduct.loaded event once. This is an interim solution
 * until we can more holistically rethink our code architecture to eliminate duplicate behaviour across EngagementProviders.
 */
_defineProperty(EngagementProvider, "hasInitializedAtLeastOneEngagementProvider", false);